<div
  id="account-banner"
  class="uk-card uk-card-secondary uk-card-body uk-padding-small uk-margin-medium-bottom"
>
  <div uk-grid>
    <div class="uk-width-auto@m uk-visible@m">
      <span class="uk-margin-small-right" uk-icon="icon:user;ratio:3;"></span>
    </div>
    <div class="uk-width-expand@m">
      <p>
        <strong>Haben Sie bereits ein GLÖCKLE-Kundenkonto?</strong>
      </p>
      <p>
        Wenn Sie sich jetzt einloggen, werden Ihre Daten automatisch übernommen.
      </p>
    </div>
    <div class="uk-width-medium uk-flex uk-flex-middle">
      <a
        class="uk-button uk-button-small uk-button-secondary"
        [href]="loginUrl"
        uk-icon="chevron-double-right"
        >Einloggen</a
      >
    </div>
  </div>
</div>
